import { gql } from 'graphql-tag';

export default gql`
  mutation CreateCreditV2($input: CreateCreditInputV2!) {
    createCreditV2(input: $input) {
      id
      user {
        formatted_name
      }
      amount
      date
      issued_by {
        formatted_name
      }
    }
  }
`;